import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

const FormTitle = ({ title }) => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ background: "#e4f0f4", height: "30px", width: "100%" }}
      mt="15px"
      fontWeight={600}
    >
      {title}
    </Grid>
  );
};

FormTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default FormTitle;
